import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

const CheckboxField = ({ input, label, disabledCheckbox, ...rest }) => (
  <FormControlLabel
    control={
      <Checkbox
        name={input.name}
        onChange={input.onChange}
        {...rest}
      />
    }
    disabled={disabledCheckbox}
    label={label}
  />
);

export default CheckboxField;
